/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `card` - card
* `ach` - ach
 */
export type PaymentMethodTypeEnum = typeof PaymentMethodTypeEnum[keyof typeof PaymentMethodTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentMethodTypeEnum = {
  card: 'card',
  ach: 'ach',
} as const;
